var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCovidBath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.011 27h7.979a4.834 4.834 0 004.721-3.826H7.289A4.834 4.834 0 0012.011 27zm-.952-16.637h4.977a2.688 2.688 0 00-2.488-1.68 2.689 2.689 0 00-2.489 1.68zm15.756 10.811H28v2h-1.267C26.247 26.464 23.413 29 19.99 29h-7.979c-3.423 0-6.258-2.536-6.745-5.826H4v-2h1.184V7.682A4.688 4.688 0 019.866 3a4.688 4.688 0 014.59 3.773 4.688 4.688 0 013.773 4.59v1H8.866v-1c0-2.182 1.509-4.007 3.533-4.522a2.674 2.674 0 00-2.533-1.84 2.685 2.685 0 00-2.682 2.681v13.492h19.631zm-15.949-3.81h-2v-3h2v3zm1.681 0h2v-3h-2v3zm5.682 0h-2v-3h2v3z",
    fill: props.color
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.99 27h-7.979a4.834 4.834 0 01-4.722-3.825h17.422A4.834 4.834 0 0119.991 27zM16.036 10.363h-4.977a2.689 2.689 0 012.489-1.68c1.125 0 2.09.696 2.488 1.68z",
    fill: "#EDF2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 22h8v8h-8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.242 21.757a6 6 0 10-8.486 8.487 6 6 0 008.486-8.487zM25.714 29l-2.384-2.384 1.212-1.212 1.172 1.172 3.532-3.532 1.212 1.212L25.714 29z",
    fill: "#54822B"
  })));
}

export default SvgIconCovidBath;